import {register} from '../vendor/theme-scripts/theme-sections';
import accordions from '../features/accordion';

register('faq', accordions);
